import Vue from 'vue'
import Router from 'vue-router'
import Frame from '@/components/Frame'
// 首页
import default_page from '@/views/Default'

// Views - Pages
import Login from '@/views/pages/LoginM'
import Register from '@/views/pages/Register'
import Package from '@/views/pages/Package'
import PkgMobile from '@/views/pages/Pkg'
import Result from '@/views/pages/Result'
import PageChain from '@/views/pages/Chain'
import PageChainDetail from '@/views/pages/ChainDetail'
import PageMap from '@/views/pages/Map'
import Insight from '@/views/pages/Insight'
import PageBoss from '@/views/pages/Boss'

// Users
import user_settting from '@/views/users/Setting'
import user_export from '@/views/users/Export'
import user_password from '@/views/users/Password'
import user_charge from '@/views/users/Charge'
import user_spend from '@/views/users/Spend'
import user_message from '@/views/users/Message'
import user_help from '@/views/users/Help'

// Sys
import sys_users from '@/views/sys/Users'
import sys_log from '@/views/sys/SysLog'
import sys_group from '@/views/sys/Group'
import sys_roles from '@/views/sys/Roles'
import sys_udb from '@/views/sys/Udb'

Vue.use(Router)

export default new Router({
    mode: 'hash', // Demo is living in GitHub.io, so required!
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [
        {
            path: '/',
            name: 'default',
            redirect: '/default',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: 'login',
                    name: 'login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                },
                {
                    path: 'default',
                    name: 'default',
                    // component: Login
                    component: default_page
                },
                {
                    path: 'package',
                    name: 'package',
                    component: Package
                },
                {
                    path: 'pkgmobile',
                    name: 'pkgmobile',
                    component: PkgMobile
                },
                {
                    path: 'result',
                    name: 'result',
                    component: Result
                },
                {
                    path: 'boss',
                    name: 'boss',
                    component: PageBoss
                },
                {
                    path: 'map',
                    name: 'map',
                    component: PageMap
                },
                {
                    path: 'chain',
                    name: 'chain',
                    component: PageChain
                },
                {
                    path: 'detail',
                    name: 'detail',
                    component: PageChainDetail
                },
                {
                    path: 'insight',
                    name: 'insight',
                    component: Insight
                }
            ]
        }, {
            path: '/',
            component: Frame,
            children: [
                {
                    path: 'user',
                    name: '用户中心',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'setting',
                            name: '用户管理',
                            component: user_settting
                        },
                        {
                            path: 'export',
                            name: '导出数据',
                            component: user_export
                        },
                        {
                            path: 'password',
                            name: '修改密码',
                            component: user_password
                        },
                        {
                            path: 'charge',
                            name: '充值记录',
                            component: user_charge
                        },
                        {
                            path: 'spend',
                            name: '消费记录',
                            component: user_spend
                        },
                        {
                            path: 'message',
                            name: '',
                            component: user_message
                        },
                        {
                            path: 'help',
                            name: '',
                            component: user_help
                        }
                    ]
                }
            ]
        }, {
            path: '/',
            component: Frame,
            children: [
                {
                    path: 'sys',
                    name: '用户中心',
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'users',
                            name: '用户管理',
                            component: sys_users
                        },
                        {
                            path: 'roles',
                            name: '角色管理',
                            component: sys_roles
                        },
                        {
                            path: 'group',
                            name: '',
                            component: sys_group
                        },
                        {
                            path: 'log',
                            name: '',
                            component: sys_log
                        },
                        {
                            path: 'udb',
                            name: '',
                            component: sys_udb
                        }
                    ]
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js